import authService from './authService';
import { buildHeaders } from "src/utils/apiUtils";


let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});


export async function createCompliance(complianceData:any) {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/compliance`, {
        method: 'POST',
        headers,
        credentials: "include",
        body: JSON.stringify(complianceData),
      });

      const data = await response.json();
      if (!response.ok ) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
  };

/** `approvedOnly` is for pickers — they offer only finished-approval compliances. */
export async function getCompliance(
  query: string, perPage: number, pageNo: number, approvedOnly = false,
  sortBy?: string, sortOrder?: 'asc' | 'desc',
) {
    try {
      const headers = await buildHeaders(BASE_URL);
      const sortParams = `${sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`;
      const response = await fetch(`${BASE_URL}/compliance?query=${query}&perPage=${perPage}&pageNo=${pageNo}${approvedOnly ? '&approvedOnly=true' : ''}${sortParams}`, {
        method: 'GET',
        headers,
        credentials: "include",
      });

      const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

/**
 * Lightweight compliance list for dropdowns/filters in OTHER modules (Survey,
 * Remediation, ...) — same filters as getCompliance, but gated only on being
 * logged in, not on the 'compliances' page permission, since a Survey/
 * Remediation user picking a compliance may not have that permission at all.
 * Use this instead of getCompliance for any <Select> of compliances; keep
 * getCompliance for the Compliance management catalog itself.
 */
export async function getComplianceSelectOptions(
  query: string, perPage: number, pageNo: number, approvedOnly = false,
) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance/select?query=${encodeURIComponent(query)}&perPage=${perPage}&pageNo=${pageNo}${approvedOnly ? '&approvedOnly=true' : ''}`, {
      method: 'GET',
      headers,
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function updateComplianceStatusApi(id: string, newStatus: string) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance/${id}`, {
      method: 'PUT',
      headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    credentials: "include",
    body: JSON.stringify({ complianceStatus: newStatus,tenantId:'eg' }),
  });
  const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

export const updateCompliance = async (id: string, data: any) => {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance/updatecomplaince/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      ...headers,
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || result.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return result;
} catch (error: any) {
    throw new Error(error);
}
};


export async function getComplianceInfo(id: string) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance/${id}`, {
      method: 'GET',
      headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    credentials: "include",
  });
  const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}


export async function getControlsWithTasks(compliance_id: any, subdomainId: any) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance-control-actions/compliance/${compliance_id}/domain/${subdomainId}`, {
      method: 'GET',
      headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    credentials: "include",
  });
  const data = await response.json();
  if (!response.ok ) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
  }
  return data;
} catch (error: any) {
  throw new Error(error);
}
}

export async function getTask(controlId:any,complianceId:any,subFieldId:any){
  try{
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance-control-actions/${controlId}/compliance/${complianceId}/domain/${subFieldId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      credentials: "include",
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}








// POST /compliance-control-actions/send-all
// Body: { complianceId }
// Old "send all / approve all control actions" flow: its Send and Approve buttons were removed from
// the Compliance list (2026-09-26) - approval goes through the approval workflow now. Kept, commented out.
// export async function sendAllControlActions(complianceId: string) {
//   try {
//     const headers = await buildHeaders(BASE_URL);
//     const response = await fetch(`${BASE_URL}/compliance-control-actions/send-all`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         ...headers,
//       },
//       credentials: 'include',
//       body: JSON.stringify({ complianceId })
//     });
// 
//     const data = await response.json();
// 
//     if (!response.ok) {
//       if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
//         throw new Error('Forbidden: You do not have permission to access this resource.');
//       }
//       throw new Error('Failed to send control actions');
//     }
// 
//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// }

// POST /compliance-control-actions/send-one
// Body: { complianceId, domainId, controlId }
export async function sendOneControlAction(complianceId: string, domainId: string, controlId: string) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance-control-actions/send-one`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      credentials: 'include',
      body: JSON.stringify({ complianceId, domainId, controlId })
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error('Failed to send control action');
    }

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

// Old "send all / approve all control actions" flow: its Send and Approve buttons were removed from
// the Compliance list (2026-09-26) - approval goes through the approval workflow now. Kept, commented out.
// export async function approveAllControlActions(complianceId: string) {
//   try {
//     const headers = await buildHeaders(BASE_URL);
//     const response = await fetch(`${BASE_URL}/compliance-control-actions/approve-all`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         ...headers,
//       },
//       credentials: "include",
//       body: JSON.stringify({
//         complianceId: complianceId
//       })
//     });
//     
//     const data = await response.json();
//     
//     if (!response.ok) {
//       if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
//         throw new Error("Forbidden: You do not have permission to access this resource.");
//       }
//       throw new Error("Failed to approve control actions");
//     }
//     
//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// }

export async function approveOneControlAction(complianceId: string, domainId: string, controlId: string) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance-control-actions/approve-one`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      credentials: "include",
      body: JSON.stringify({
        complianceId: complianceId,
        domainId: domainId,
        controlId: controlId
      })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to approve control action");
    }
    
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function refuseOneControlAction(complianceId: string, domainId: string, controlId: string, reason?: string) {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/compliance-control-actions/refuse-one`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      credentials: "include",
      body: JSON.stringify({
        complianceId: complianceId,
        domainId: domainId,
        controlId: controlId,
        reason: reason,
      })
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to refuse control action");
    }

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}



export async function deleteCompliance(
  id: string,
): Promise<{ success: boolean; pendingApproval?: boolean; restarted?: boolean; message?: string }> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/${id}`, {
      method: 'DELETE',
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      return {
        success: false,
        message: (result as { message?: string }).message || 'Failed to delete compliance',
      };
    }
    // Keep pendingApproval/restarted: a delete may only be held for approval.
    return {
      success: result.success !== false,
      pendingApproval: Boolean(result.pendingApproval),
      restarted: Boolean(result.restarted),
      message: (result as { message?: string }).message,
    };
  } catch (error: any) {
    console.error('Error deleting compliance:', error);
    return { success: false, message: error?.message || 'Failed to delete compliance' };
  }
}

export async function deleteCompliancesBulk(ids: string[]): Promise<{ success: boolean; message?: string }> {
  try {
    if (!Array.isArray(ids) || ids.length === 0) {
      return { success: false, message: 'No items selected' };
    }
    const response = await authService.apiCall(`${BASE_URL}/compliance/bulk-delete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids }),
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      return {
        success: false,
        message: (result as { message?: string }).message || 'Failed to delete compliances',
      };
    }
    return { success: result.success !== false, message: (result as { message?: string }).message };
  } catch (error: any) {
    console.error('Error bulk-deleting compliances:', error);
    return { success: false, message: error?.message || 'Failed to delete compliances' };
  }
}

export async function getComplianceStatusControlsBatch(complianceId: string, domainIds: string[]) {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/compliance-control-actions/compliance/${complianceId}/status-controls-batch`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domainIds: domainIds ?? [] }),
      },
    );
    if (!response.ok) {
      throw new Error('Failed to load compliance status controls');
    }
    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error fetching compliance status controls batch:', error);
    throw new Error(error?.message || 'Error fetching compliance status controls');
  }
}
